<header class="md3-header"
        [attr.data-scroll]="scrollState()"
        [style.--scroll-progress]="scrollProgress()">
  <!-- Scroll Progress Indicator -->
  <div class="md3-scroll-progress"
       [style.transform]="'scaleX(' + scrollProgress() + ')'">
  </div>

  <div class="md3-header-container">
    <!-- Brand/Logo -->
    <div class="md3-header-brand"
         (click)="navigateTo('/home')"
         role="button"
         tabindex="0"
         [class.hero-mode]="isOverHero()">
      <img src="assets/images/logos/FT-Color-Wide.svg"
           alt="FARTURK Registry"
           class="md3-header-logo"
           [class.glow]="scrollState() === 'hero'">
    </div>

    <!-- Desktop Navigation -->
    <nav class="md3-header-nav" aria-label="Ana navigasyon">
      <button class="md3-nav-link"
              (click)="navigateTo('/patients')"
              [class.active]="isActive('/patients')"
              [attr.aria-current]="isActive('/patients') ? 'page' : null">
        <span class="md3-icon">people</span>
        <span>Hastalar</span>
      </button>

      <button class="md3-nav-link"
              (click)="navigateTo('/analytics')"
              [class.active]="isActive('/analytics')"
              [attr.aria-current]="isActive('/analytics') ? 'page' : null">
        <span class="md3-icon">insights</span>
        <span>Göstergeler</span>
      </button>

      @if (authService.isAdmin()) {
        <button class="md3-nav-link"
                (click)="navigateTo('/admin')"
                [class.active]="isActive('/admin')"
                [attr.aria-current]="isActive('/admin') ? 'page' : null">
          <span class="md3-icon">admin_panel_settings</span>
          <span>Yönetim</span>
        </button>
      }
    </nav>

    <!-- Header Actions -->
    <div class="md3-header-actions">
      <!-- Theme Toggle (3-way) -->
      <div class="md3-theme-toggle" role="radiogroup" aria-label="Tema seçimi">
        <button class="md3-theme-button"
                (click)="setTheme('light')"
                [class.active]="getCurrentTheme() === 'light'"
                [attr.aria-checked]="getCurrentTheme() === 'light'"
                role="radio"
                aria-label="Açık tema">
          <span class="md3-icon">light_mode</span>
        </button>
        <button class="md3-theme-button"
                (click)="setTheme('system')"
                [class.active]="getCurrentTheme() === 'system'"
                [attr.aria-checked]="getCurrentTheme() === 'system'"
                role="radio"
                aria-label="Sistem teması">
          <span class="md3-icon">contrast</span>
        </button>
        <button class="md3-theme-button"
                (click)="setTheme('dark')"
                [class.active]="getCurrentTheme() === 'dark'"
                [attr.aria-checked]="getCurrentTheme() === 'dark'"
                role="radio"
                aria-label="Koyu tema">
          <span class="md3-icon">dark_mode</span>
        </button>
      </div>

      <!-- Language Selector -->
      <button class="md3-header-icon-button"
              (click)="toggleLanguageMenu()"
              aria-label="Dil seçimi"
              [attr.aria-expanded]="languageMenuOpen()">
        <span class="md3-icon">translate</span>
      </button>

      <!-- Language Dropdown -->
      <div class="md3-dropdown md3-lang-dropdown"
           [attr.data-open]="languageMenuOpen()"
           role="menu">
        <div class="md3-dropdown-header">
          <span class="md3-icon">language</span>
          <span>Dil Seçimi</span>
        </div>
        <div class="md3-dropdown-divider"></div>
        <button class="md3-dropdown-item"
                (click)="changeLanguage('tr')"
                [class.active]="currentLanguage() === 'tr'"
                role="menuitem">
          <span class="md3-icon">flag</span>
          <span>Türkçe</span>
          @if (currentLanguage() === 'tr') {
            <span class="md3-icon" style="margin-left: auto;">check</span>
          }
        </button>
        <button class="md3-dropdown-item"
                (click)="changeLanguage('en')"
                [class.active]="currentLanguage() === 'en'"
                role="menuitem">
          <span class="md3-icon">flag</span>
          <span>English</span>
          @if (currentLanguage() === 'en') {
            <span class="md3-icon" style="margin-left: auto;">check</span>
          }
        </button>
      </div>

      <!-- User Section -->
      @if (authService.currentUser()) {
        <!-- User Profile Button -->
        <button class="md3-user-button"
                (click)="toggleUserMenu()"
                [attr.aria-expanded]="userMenuOpen()">
          <div class="md3-user-avatar">
            @if (authService.userProfile()?.photoURL) {
              <img [src]="authService.userProfile()?.photoURL"
                   alt="Kullanıcı avatarı">
            } @else {
              <span class="md3-icon">account_circle</span>
            }
          </div>
          <div class="md3-user-info">
            <span class="md3-user-name">
              {{ authService.userProfile()?.firstName }} {{ authService.userProfile()?.lastName }}
            </span>
            <span class="md3-user-role">
              {{ getRoleDisplayName() }}
            </span>
          </div>
          <span class="md3-icon md3-dropdown-icon">expand_more</span>
        </button>

        <!-- User Dropdown Menu -->
        <div class="md3-dropdown md3-user-dropdown"
             [attr.data-open]="userMenuOpen()"
             role="menu">
          <div class="md3-user-header">
            <div class="md3-user-avatar-large">
              @if (authService.userProfile()?.photoURL) {
                <img [src]="authService.userProfile()?.photoURL"
                     alt="Kullanıcı avatarı">
              } @else {
                <div class="md3-avatar-placeholder">
                  <span class="md3-icon">account_circle</span>
                </div>
              }
            </div>
            <div class="md3-user-details">
              <div class="md3-user-fullname">
                {{ authService.userProfile()?.title ? authService.userProfile()?.title + ' ' : '' }}{{ authService.userProfile()?.firstName }} {{ authService.userProfile()?.lastName }}
              </div>
              <div class="md3-user-email">{{ authService.currentUser()?.email }}</div>
              <span class="md3-user-badge">{{ getRoleDisplayName() }}</span>
            </div>
          </div>

          <div class="md3-dropdown-divider"></div>

          <button class="md3-dropdown-item"
                  (click)="navigateTo('/profile')"
                  role="menuitem">
            <span class="md3-icon">person</span>
            <span>Profil Ayarları</span>
          </button>

          <button class="md3-dropdown-item"
                  (click)="navigateTo('/data-sharing')"
                  role="menuitem">
            <span class="md3-icon">shield_person</span>
            <span>Veri Paylaşımı</span>
          </button>

          @if (authService.isAdmin()) {
            <div class="md3-dropdown-divider"></div>
            <button class="md3-dropdown-item"
                    (click)="navigateTo('/admin/users')"
                    role="menuitem">
              <span class="md3-icon">manage_accounts</span>
              <span>Kullanıcı Yönetimi</span>
            </button>
            <button class="md3-dropdown-item"
                    (click)="navigateTo('/admin/centers')"
                    role="menuitem">
              <span class="md3-icon">business</span>
              <span>Merkez Yönetimi</span>
            </button>
          }

          <div class="md3-dropdown-divider"></div>

          <button class="md3-dropdown-item danger"
                  (click)="logout()"
                  role="menuitem">
            <span class="md3-icon">logout</span>
            <span>Çıkış Yap</span>
          </button>
        </div>
      } @else {
        <!-- Login Button -->
        <button class="md3-nav-link md3-login-button"
                (click)="openLoginModal()">
          <span class="md3-icon">login</span>
          <span>Giriş Yap</span>
        </button>
      }

      <!-- Mobile Menu Toggle -->
      <button class="md3-mobile-menu-button"
              (click)="toggleMobileMenu()"
              [attr.aria-expanded]="mobileMenuOpen()"
              aria-label="Mobil menü">
        <span class="md3-icon">{{ mobileMenuOpen() ? 'close' : 'menu' }}</span>
      </button>
    </div>
  </div>

  <!-- Mobile Menu -->
  <nav class="md3-mobile-menu"
       [attr.data-open]="mobileMenuOpen()"
       aria-label="Mobil navigasyon">
    <a class="md3-mobile-nav-link"
       (click)="navigateTo('/patients')"
       [attr.aria-current]="isActive('/patients') ? 'page' : null">
      <span class="md3-icon">people</span>
      <span>Hastalar</span>
    </a>

    <a class="md3-mobile-nav-link"
       (click)="navigateTo('/analytics')"
       [attr.aria-current]="isActive('/analytics') ? 'page' : null">
      <span class="md3-icon">insights</span>
      <span>Göstergeler</span>
    </a>

    @if (authService.isAdmin()) {
      <a class="md3-mobile-nav-link"
         (click)="navigateTo('/admin')"
         [attr.aria-current]="isActive('/admin') ? 'page' : null">
        <span class="md3-icon">admin_panel_settings</span>
        <span>Yönetim Paneli</span>
      </a>
    }

    @if (authService.currentUser()) {
      <div class="md3-dropdown-divider"></div>
      <a class="md3-mobile-nav-link"
         (click)="navigateTo('/profile')">
        <span class="md3-icon">person</span>
        <span>Profil</span>
      </a>
      <a class="md3-mobile-nav-link danger"
         (click)="logout()">
        <span class="md3-icon">logout</span>
        <span>Çıkış Yap</span>
      </a>
    }
  </nav>
</header>

<!-- Login Modal -->
@if (loginModalOpen()) {
  <div class="md3-modal-backdrop"
       [attr.data-open]="loginModalOpen()">
    <div class="md3-login-modal"
         [attr.data-open]="loginModalOpen()"
         role="dialog"
         aria-labelledby="login-modal-title"
         (click)="$event.stopPropagation()">
      <button class="md3-modal-close"
              (click)="closeLoginModal()"
              aria-label="Kapat">
        <span class="md3-icon">close</span>
      </button>

      <div class="md3-modal-header">
        <h2 id="login-modal-title" class="md3-modal-title">Hoş Geldiniz</h2>
        <p class="md3-modal-subtitle">FARTURK Registry'e giriş yapın</p>
      </div>

      <div class="md3-modal-body">
        <app-login-form
          (loginSuccess)="onLoginSuccess()"
          (loginCancel)="closeLoginModal()">
        </app-login-form>
      </div>
    </div>
  </div>
}